// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Xero Accounts Styles */

.xero-accounts {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.accounts-header {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.accounts-header h3 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.accounts-header p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

.accounts-table-container {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  max-width: 100%;
  position: relative;
}

.accounts-table-container::after {
  content: "← Scroll to see all columns →";
  position: absolute;
  top: 8px;
  right: 16px;
  background: #f1f5f9;
  color: #64748b;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  z-index: 10;
  pointer-events: none;
}

.accounts-table {
  width: 100%;
  min-width: 2000px;
  /* Ensure all columns are visible */
  border-collapse: collapse;
  font-size: 14px;
}

.accounts-table thead {
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.accounts-table th {
  padding: 16px 12px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-right: 1px solid #e2e8f0;
  white-space: nowrap;
  min-width: 120px;
  /* Minimum width for each column */
}

.accounts-table th:last-child {
  border-right: none;
}

.accounts-table tbody tr {
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.2s ease;
}

.accounts-table tbody tr:hover {
  background-color: #f8fafc;
}

.accounts-table tbody tr:last-child {
  border-bottom: none;
}

.accounts-table td {
  padding: 12px;
  border-right: 1px solid #e2e8f0;
  vertical-align: top;
  word-wrap: break-word;
  min-width: 120px;
  /* Consistent with header */
  max-width: 300px;
  /* Allow some flexibility for longer content */
}

.accounts-table td:last-child {
  border-right: none;
}

/* Specific column styles */
.account-code {
  font-weight: 600;
  color: #1e293b;
  font-family: 'Courier New', monospace;
}

.account-name {
  font-weight: 500;
  color: #1e293b;
}

.type-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.type-badge.revenue {
  background-color: #dcfce7;
  color: #166534;
}

.type-badge.expense {
  background-color: #fef3c7;
  color: #92400e;
}

.type-badge.asset {
  background-color: #dbeafe;
  color: #0D3B66;
}

.type-badge.liability {
  background-color: #fce7f3;
  color: #be185d;
}

.type-badge.equity {
  background-color: #f3e8ff;
  color: #7c3aed;
}

.type-badge.directcosts {
  background-color: #fef2f2;
  color: #dc2626;
}

.type-badge.current {
  background-color: #ecfdf5;
  color: #059669;
}

.type-badge.fixed {
  background-color: #f0f9ff;
  color: #0284c7;
}

.type-badge.inventory {
  background-color: #fefce8;
  color: #ca8a04;
}

.type-badge.currliab {
  background-color: #fdf2f8;
  color: #be185d;
}

.type-badge.termliab {
  background-color: #f0fdf4;
  color: #16a34a;
}

.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.status-badge.active {
  background-color: #dcfce7;
  color: #166534;
}

.status-badge.inactive {
  background-color: #fef2f2;
  color: #dc2626;
}

.boolean-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
}

.boolean-badge.true {
  background-color: #dcfce7;
  color: #166534;
}

.boolean-badge.false {
  background-color: #f3f4f6;
  color: #6b7280;
}

.description {
  max-width: 300px;
  line-height: 1.4;
}

.reporting-code {
  font-size: 12px;
  color: #64748b;
}

.updated-date {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}

/* Summary section */
.accounts-summary {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.accounts-summary h4 {
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.summary-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.summary-stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stat-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

.stat-value {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

/* Empty state */
.no-accounts {
  text-align: center;
  padding: 48px 24px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.empty-icon {
  font-size: 48px;
  opacity: 0.5;
}

.empty-state h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #374151;
}

.empty-state p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

/* Responsive design */
@media (max-width: 1200px) {
  .accounts-table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    /* Smooth scrolling on iOS */
  }

  .accounts-table {
    min-width: 2000px;
    /* Keep full width for all columns */
  }
}

@media (max-width: 768px) {
  .accounts-header {
    padding: 16px;
  }

  .accounts-header h3 {
    font-size: 18px;
  }

  .accounts-table th,
  .accounts-table td {
    padding: 8px;
    font-size: 12px;
  }

  .summary-stats {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 12px;
  }

  .stat-value {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/xero/XeroAccounts.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Xero Accounts Styles */\n\n.xero-accounts {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.accounts-header {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.accounts-header h3 {\n  margin: 0 0 8px 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.accounts-header p {\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.accounts-table-container {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  max-width: 100%;\n  position: relative;\n}\n\n.accounts-table-container::after {\n  content: \"← Scroll to see all columns →\";\n  position: absolute;\n  top: 8px;\n  right: 16px;\n  background: #f1f5f9;\n  color: #64748b;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  z-index: 10;\n  pointer-events: none;\n}\n\n.accounts-table {\n  width: 100%;\n  min-width: 2000px;\n  /* Ensure all columns are visible */\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.accounts-table thead {\n  background: #f8fafc;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.accounts-table th {\n  padding: 16px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-right: 1px solid #e2e8f0;\n  white-space: nowrap;\n  min-width: 120px;\n  /* Minimum width for each column */\n}\n\n.accounts-table th:last-child {\n  border-right: none;\n}\n\n.accounts-table tbody tr {\n  border-bottom: 1px solid #e2e8f0;\n  transition: background-color 0.2s ease;\n}\n\n.accounts-table tbody tr:hover {\n  background-color: #f8fafc;\n}\n\n.accounts-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.accounts-table td {\n  padding: 12px;\n  border-right: 1px solid #e2e8f0;\n  vertical-align: top;\n  word-wrap: break-word;\n  min-width: 120px;\n  /* Consistent with header */\n  max-width: 300px;\n  /* Allow some flexibility for longer content */\n}\n\n.accounts-table td:last-child {\n  border-right: none;\n}\n\n/* Specific column styles */\n.account-code {\n  font-weight: 600;\n  color: #1e293b;\n  font-family: 'Courier New', monospace;\n}\n\n.account-name {\n  font-weight: 500;\n  color: #1e293b;\n}\n\n.type-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.type-badge.revenue {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.type-badge.expense {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.type-badge.asset {\n  background-color: #dbeafe;\n  color: #0D3B66;\n}\n\n.type-badge.liability {\n  background-color: #fce7f3;\n  color: #be185d;\n}\n\n.type-badge.equity {\n  background-color: #f3e8ff;\n  color: #7c3aed;\n}\n\n.type-badge.directcosts {\n  background-color: #fef2f2;\n  color: #dc2626;\n}\n\n.type-badge.current {\n  background-color: #ecfdf5;\n  color: #059669;\n}\n\n.type-badge.fixed {\n  background-color: #f0f9ff;\n  color: #0284c7;\n}\n\n.type-badge.inventory {\n  background-color: #fefce8;\n  color: #ca8a04;\n}\n\n.type-badge.currliab {\n  background-color: #fdf2f8;\n  color: #be185d;\n}\n\n.type-badge.termliab {\n  background-color: #f0fdf4;\n  color: #16a34a;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.status-badge.active {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.status-badge.inactive {\n  background-color: #fef2f2;\n  color: #dc2626;\n}\n\n.boolean-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.boolean-badge.true {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.boolean-badge.false {\n  background-color: #f3f4f6;\n  color: #6b7280;\n}\n\n.description {\n  max-width: 300px;\n  line-height: 1.4;\n}\n\n.reporting-code {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.updated-date {\n  font-size: 12px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n/* Summary section */\n.accounts-summary {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.accounts-summary h4 {\n  margin: 0 0 16px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.summary-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.summary-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.stat-label {\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n/* Empty state */\n.no-accounts {\n  text-align: center;\n  padding: 48px 24px;\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.empty-icon {\n  font-size: 48px;\n  opacity: 0.5;\n}\n\n.empty-state h4 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.empty-state p {\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n/* Responsive design */\n@media (max-width: 1200px) {\n  .accounts-table-container {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    /* Smooth scrolling on iOS */\n  }\n\n  .accounts-table {\n    min-width: 2000px;\n    /* Keep full width for all columns */\n  }\n}\n\n@media (max-width: 768px) {\n  .accounts-header {\n    padding: 16px;\n  }\n\n  .accounts-header h3 {\n    font-size: 18px;\n  }\n\n  .accounts-table th,\n  .accounts-table td {\n    padding: 8px;\n    font-size: 12px;\n  }\n\n  .summary-stats {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 12px;\n  }\n\n  .stat-value {\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
